import { memo, useState } from "react";

// =====================================================
// LOVE LEADERBOARD — PROFILE AVATAR
//
// One avatar used by every leaderboard card. The profile picture is OPTIONAL,
// so this component treats "no image" as a normal state, not an error: it draws
// the person's initial on the card's own glass instead.
//
// A stored URL can also stop resolving (a deleted Cloudinary asset, a blocked
// network). `onError` switches to the same fallback, which is what guarantees
// the card never shows a browser's broken-image icon.
// =====================================================

const initialOf = (name) => {
  const first = String(name || "").trim().charAt(0);
  return first ? first.toUpperCase() : "★";
};

const LoveAvatar = memo(function LoveAvatar({ src, name, className = "" }) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  return (
    <div className={`ll-avatar ${showImage ? "" : "ll-avatar-fallback"} ${className}`.trim()}>
      {showImage ? (
        <img
          src={src}
          alt={name || "Profile"}
          className="ll-avatar-img"
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="ll-avatar-initial" aria-hidden="true">{initialOf(name)}</span>
      )}
    </div>
  );
});

export default LoveAvatar;
